jQuery(document).ready(function ($) {
    if ($('.upload-placeholder-uk .codedropz-upload-inner')) {
        $('.upload-placeholder-uk .codedropz-upload-inner h3')[0].innerHTML = 'протягніть файл';
        $('.upload-placeholder-uk .codedropz-upload-inner span')[0].innerHTML = 'або';
        $('.upload-placeholder-uk .codedropz-upload-inner .codedropz-btn-wrap a')[0].innerHTML = 'виберіть з диску';
    }
});